<template>
  <div>
    <TableFilters
      :filters="['shop', 'product']"
      v-model="filter"
      :columns="columns"
      @updateColumnsTable="updateColumnsTable"
      :export="[`outofstockexport`]"
    ></TableFilters>

    <v-row class="py-0 my-0">
      <v-col cols="12" md="12" lg="7" class="pa-5">
        <v-btn-toggle v-model="toggle_exclusive">
          <v-btn @click="viewpdfFile()"> View Report </v-btn>
          <v-btn @click="pdfdownload()"> Generate PDF </v-btn>
          <v-btn @click="exceldownload()"> Generate CSV </v-btn>
        </v-btn-toggle>
      </v-col>
    </v-row>
    <v-card class="lighten-12 mt-2" v-show="false">
      <v-container fluid class="light gray lighten-12">
        <v-row>
          <v-card-text class="pa-0">
            <v-data-table
              :items-per-page="1000"
              :headers="headers"
              :items="shopStock"
              :single-expand="singleExpand"
              item-key="name"
              class="row-pointer"
              id="indextable8"
            >
              <template v-slot:no-data>
                <div class="mt-16 container justify-center item-center">
                  <noData name="Purchase" />
                </div>
              </template>

              <template v-slot:top>
                <tr>
                  <th>Product Name:</th>
                  <th>{{ filterDatas.productquery }}</th>
                  <th></th>
                  <th>Shop Name:</th>
                  <th>{{ filterDatas.shopquery }}</th>
                </tr>
              </template>

              <template v-slot:item.shop="{ item }">{{
                item.shop.name ? item.shop.name : '.......'
              }}</template>

              <template v-slot:item.code="{ item }">{{
                item.product.code ? item.product.code : '.......'
              }}</template>
              <template v-slot:item.batch="{ item }">{{
                item.batch.batch ? item.batch.batch : '.......'
              }}</template>
              <template v-slot:item.unit="{ item }">{{
                item.unit.name ? item.unit.name : '.......'
              }}</template>
              <template v-slot:item.available_stock="{ item }">{{
                item.available_stock
              }}</template>

              <template v-slot:item.damage="{ item }">{{
                item.damage
              }}</template>

              <template v-slot:item.reorder="{ item }">{{
                item.reorder_level
              }}</template>
            </v-data-table>
          </v-card-text>
        </v-row>
      </v-container>
    </v-card>
    <!-- </v-card> -->
    <div class="d-flex justify-center align-center"></div>
  </div>
</template>
<script>
import TableFilters from '@/components/base/TableFilters';
import jsPDF from 'jspdf';
import autoTable from 'jspdf-autotable';
import XLSX from 'xlsx';
import { DateTime } from '@grapecity/wijmo';
import moment from 'moment';
import { mapState } from 'vuex';

import _ from 'lodash';
export default {
  components: {
    TableFilters,
  },
  data() {
    return {
      hide: 'auto',
      singleExpand: false,
      errormsg: false,

      isLoading: true,
      warehouseerror: '',
      columns: [
        {
          text: 'No',
          value: 'no',
          show: true,
          disabled: false,
          width: '14%',
          render: (item) => item?.no,
        },

        {
          text: 'Shop Name',
          value: 'shop',
          show: true,
          disabled: false,
          width: '14%',
          render: (item) => item?.shop.name,
        },
        {
          text: 'Product name',
          value: 'name',
          show: true,
          disabled: false,
          width: '14.2%',
          render: (item) => item?.product.name,
        },

        {
          text: 'Code',
          value: 'code',
          show: true,
          disabled: false,
          width: '14.2%',
          render: (item) => item?.product.code,
        },

        {
          text: 'Batch',
          value: 'batch',
          show: true,
          disabled: false,
          width: '14.2%',
          render: (item) => item?.batch.batch,
        },
        {
          text: 'Unit',
          value: 'unit',
          show: true,
          disabled: false,
          width: '14.2%',
          render: (item) => item?.unit.name,
        },

        {
          text: 'Available Stock',
          value: 'available_stock',
          show: true,
          disabled: false,
          width: '14.2%',
          render: (item) => item?.available_stock,
        },

        {
          text: 'Damaged Stock',
          value: 'damage',
          show: true,
          disabled: false,
          width: '14.2%',
          render: (item) => item?.damage,
        },

        {
          text: 'Reorder Level',
          value: 'reorder',
          show: true,
          disabled: false,
          width: '14.2%',
          render: (item) => item?.reorder_level,
        },
      ],
      shopStock: [],
      filter: {
        warehouse: '',
        product: '',
        dateRange: '',
      },
    };
  },
  methods: {
    updateColumnsTable() {
      this.$store.commit('UPDATE_PDF_VISIBLE', false);
      this.$store.commit('UPDATE_PDFLOADNG_VISIBLE', true);
      setTimeout(() => {
        this.$store.commit('UPDATE_PDF_HEADERS', this.headers);
        this.$store.commit('UPDATE_PDF_VISIBLE', true);
        this.$store.commit('UPDATE_PDFLOADNG_VISIBLE', false);
      }, 100);
    },

    generateReport(callBack = () => {}) {
      this.$store.commit('UPDATE_PDF_VISIBLE', true);
      this.$store.commit('UPDATE_PDFLOADNG_VISIBLE', true);

      var filter = this.filter;
      this.$store

        .dispatch('report/getShopStockReportProductManagement', filter)
        .then((res) => {
          this.shopStock = res.data.data;
          let i = 1;
          this.shopStock.map((p) => {
            p.no = i;
            i++;
          });
          setTimeout(() => {
            // Update Pdf To List
            this.$store.commit('UPDATE_PDF_HEADERS', this.headers);
            // Update Pdf To List Datas
            this.$store.commit('UPDATE_PDF_DATAS', this.shopStock);
            // Update Pdf To List_Title
            this.$store.commit('UPDATE_PDF_TITLE', 'Shop Stock Report');
            this.$store.commit('UPDATE_PDFLOADNG_VISIBLE', false);

            callBack();
          }, 100);
        })
        .catch((err) => {
          this.isLoading = false;
          this.$store.commit('UPDATE_PDFLOADNG_VISIBLE', false);
          this.$store.commit('UPDATE_PDF_VISIBLE', false);

          this.messages = err.data.title;
        });
    },
    async viewpdfFile() {
      await this.generateReport();
      setTimeout(() => {
        if (this.shopStock.length > 0) {
          this.$store.commit('UPDATE_PDF_VISIBLE', true);
          this.$store.commit('UPDATE_PDFLOADNG_VISIBLE', false);
        }
      }, 1000);
    },

    //Product Details Export Pdf
    async pdfdownload() {
      const printPdf = () => {
        let Data = _.cloneDeep(this.shopStock);
        for (let x = 0; x < Data.length; x++) {
          Data[x].shop = Data[x].shop.name;
          Data[x].code = Data[x].product.code;
          Data[x].batch = Data[x].batch.batch;
          Data[x].available_stock = Data[x].available_stock;
          Data[x].damage = Data[x].damage;
          Data[x].reorder = Data[x].reorder_level;
          Data[x].unit = Data[x].unit.name;
          Data[x].name = Data[x].product.name;
        }
        var rows = Data;
        var doc = jsPDF({
          orientation: 'landscape',
        });
        doc.setFontSize(13);
        // doc.setFontType("bold");
        doc.setTextColor(26, 26, 26);
        doc.setFont('helvetica', 'normal');
        doc.text('Purchase Order Report', 14, 6);

        doc.setFontSize(9);
        doc.text(
          246,
          6,
          `Generated Date and Time  -  ${moment(today).format(
            'DD-MM-YYYY HH:MM:SS',
          )}`,
          'center',
        );
        // doc.text(60, 10, `Total Amount :- ${this.total.toFixed(2)}`);
        // doc.text(100, 10, `Grand Total :- ${this.grandTotal.toFixed(2)}`);
        // doc.text(140, 10, `Discount Total :- ${this.discountTotal.toFixed(2)}`);
        // doc.text(180, 10, `Product :-${this.filterDatas.productquery}`);
        // doc.text(220, 10, `Shop:-${this.filterDatas.shopquery}`);
        doc.setFontSize(10);

        const conditions = [
          { key: 'shopquery', label: 'Shop' },
          { key: 'productquery', label: 'Product' },
        ];

        // Function to get text based on filter data
        const getText = (key, label, value) => {
          return value ? `${label} - ${value}` : '';
        };

        // Iterate over conditions and build the text
        let height = conditions.reduce((acc, condition) => {
          const value = this.filterDatas[condition.key];
          const text = getText(condition.key, condition.label, value);

          if (text) {
            doc.text(text, 15, acc);
            return acc + 5; // Increment
          }

          return acc;
        }, 12); // Initial offset

        // Set a default height if no conditions matched
        height = height || 20;
        doc.autoTable(
          this.headers.map((h) => {
            return { title: h.text, dataKey: h.value };
          }),
          rows,
          {
            didParseCell: function (data) {
              if (data.column.dataKey === 'addsress') {
                data.cell.text = data.cell.raw.country;
              }
            },
            startY: height,
          },
        );
        const today = new DateTime();
        doc.save(`${moment(today).format('DD-MM-YYYY')}-Shop Stock.pdf`);
      };
      this.generateReport(printPdf);
    },

    //Product Details Export Excel
    async exceldownload() {
      const printExcel = () => {
        var data = document.getElementById('indextable8');
        const today = new DateTime();
        const headData = XLSX.utils.table_to_sheet(data);
        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(
          wb,
          headData,
          moment(today).format('DD-MM-YYYY'),
        );
        XLSX.writeFile(
          wb,
          `${moment(today).format('DD-MM-YYYY')}-Shop Stock.xlsx`,
        );
      };
      this.generateReport(printExcel);
    },
  },
  created() {
    this.$store.commit('UPDATE_PDF_VISIBLE', false);
    this.$store.commit('UPDATE_PDFLOADNG_VISIBLE', false);
  },
  computed: {
    // Filter - return selected table fields
    headers: function () {
      return this.columns.filter((item) => item.show == true);
    },

    ...mapState(['filterDatas']),
  },
};
</script>
